<!-- LogoutConfirmPopup.vue -->
<template>
  <div class="logout-popup-overlay">
    <div class="logout-popup">
      <p class="popup-message">
        Are you sure you want to logout?
      </p>

      <div class="popup-actions">
        <button class="cancel-btn" @click="logoutPopupClosedMethod">
          Cancel
        </button>

        <button class="logout-btn" @click="logoutMethod">
          Logout
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from '@/main';
import { broadcastLogout } from '@/utils/authChannel';

export default {
  name: 'LogoutConfirmPopup',
  methods: {
    logoutPopupClosedMethod() {
      bus.$emit('logoutCnfrmPopupBus', false);
      this.enableScroll();
    },
    logoutMethod() {
      this.$store.dispatch('logoutAction')
        .then(() => {
          // Broadcast logout command cleanly using the new utility
          broadcastLogout();
          this.enableScroll();
        })
        .catch((err) => {
          console.error("Logout failed:", err);
        });
    },
    enableScroll() {
      document.body.classList.remove('body_right_scroll_remove');
    }
  },
  // Good practice: Ensure scroll behavior resets if the component unmounts unexpectedly
  beforeDestroy() {
    this.enableScroll();
  }
}
</script>
<style scoped lang="scss">
.logout-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.92);

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 999;
}

.logout-popup {
  background: #000;
  max-width: 400px;
  width: 100%;
  margin: 0px auto;
  border-radius: 5px;
  padding: 40px 25px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  color: #ffffff;
  -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
  box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
}

.popup-title {
  margin-bottom: 12px;
  font-size: 22px;
  font-weight: 600;
  color: #ffffff;
}

.popup-message {
  margin-bottom: 40px;
  color: #ffffff;
  font-size: 20px;
  text-align: center;
}

.popup-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.cancel-btn,
.logout-btn {
  font-size: 16px;
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  padding: 10px 5px;
  min-width: 100px;
  line-height: 1;
  border-radius: 3px !important;
  outline: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: none !important;
  &:hover{
    background: #ffe738 !important;
    color: #22292f !important;
  }
}

.cancel-btn {
  background: rgba(255, 18, 18, 0.5);
  color: #fff;
}

.logout-btn {
  background: rgba(33, 228, 0, 0.5);
  color: #fff;
  margin-left: 15px;
}
</style>